import { computed  } from "@vue/composition-api";
import store from "@/store";
import { LOG_LEVELS, LOG_MESSAGES, LOG_MESSAGE_CODES } from "@/utils/logCatalog";

function resolveLang() {
    return (
        store.getters["user/getPreferences"]?.lang ||
        "en"
    );
}

function resolveLogMessages(obj) {
    if (!obj || typeof obj !== "object") return obj;

    const lang = resolveLang(); 
    const clone = { ...obj };

    if ("logmessage" in clone && typeof clone.logmessage === "number") {
        clone.logmessage =
            LOG_MESSAGES?.[clone.logmessage]?.[lang] ??
            LOG_MESSAGES?.[clone.logmessage]?.en ??
            clone.logmessage;
    }

    return clone;
}

  
export function useLogger() {

    const user = computed(() => store.getters["user/getUser"]);

    function basePayload() {
    const lang = resolveLang();
    return {
        ip_address: "",     // (left blank)
        client_host: "",    // (left blank)
        provider: "",       // (left blank)
        level: LOG_LEVELS.INFO, // log level codes (0–7)
                                // EMERGENCY => 0
                                // ALERT     => 1
                                // CRITICAL  => 2
                                // ERROR     => 3
                                // WARNING   => 4
                                // NOTICE    => 5
                                // INFO      => 6
                                // DEBUG     => 7
        message: LOG_LEVELS.INFO, // short and clear description of the event message, 
        description: "", //resolveMessage(LOG_MESSAGE_CODES.OK, lang), // message codes (100x / 200x / 300x)   
        path: "", // current router path
        resource: "",       // resource being affected (e.g. video-tour, video-wall, tab)
        action: "",         // performed action: view | create | update | delete | error VIEW OPENED
        data: {},           // object with relevant event information
                            // e.g. { tabId, name, widget, location }
        old_data: {},       // old data changes
        tenant_cat: "[]",     // (left blank)
        user_id: user.value?.id || null, // user id (from store)
        target: "",         // (left blank)
        device_id: "",      // (left blank)
        lang, // current language (i18n): en | es | pt
        // module: "module",
        // section: "section",
        // function: "function",
        // type: "type",
        // ip: "ip",
        // identifier: "identifier",
    };
    }

    function fireAndForget(promise) {
        try {
            if (promise && typeof promise.then === "function") {
            promise.catch(() => {});
            }
        } catch (_) {}
    }

    function send(payload) {
        try {
            const lang = resolveLang();
        
            const finalDescription = payload.description
            ? `El usuario ${user.value?.user} ${payload.description}`
            : "";
        
            const formattedData = resolveLogMessages(payload.data);
            const formattedOldData = resolveLogMessages(payload.old_data);
        
            const stringData = JSON.stringify(formattedData || {});
            const stringOldData = JSON.stringify(formattedOldData || {});
        
            const action = store.dispatch("logs/logAction", {
            ...payload,
            resource: payload.resource ? String(payload.resource).toUpperCase() : "",
            action: payload.action ? String(payload.action).toUpperCase() : "",
            message: payload.level,
            description: finalDescription,
            data: stringData,
            old_data: stringOldData,
            user_id: payload.user_id != null ? String(payload.user_id) : "",
            lang,
            });
        
            fireAndForget(action);
        
        } catch (_) {
            console.log('Error, Cannot send log:', _);
        }
    }
    
    function logAction({
        action = "",
        resource = "",
        message = LOG_LEVELS.INFO,
        description = "",
        data = {},
        old_data = {},
        level = LOG_LEVELS.INFO,
        path = "",
    }) {
    send({
        ...basePayload(),
        level,
        message: level,
        description,
        resource,
        action,
        data,
        old_data,
        path,
    });
    }
      

    return {
    logAction,
    LOG_LEVELS,
    LOG_MESSAGE_CODES,
    };
}
